<template>
  <div>
    <p>
      <span
        v-html="
          $t(activity.activityType, {
            count: activity.numberOfFiles,
            senderName,
            senderFullEmail,
            receiver,
            receiverFullEmail,
            otherReceivers
          })
        "
      ></span>
    </p>
    <small>{{ activity.createdAt | activityDate }}</small>
  </div>
</template>

<script>
export default {
  name: "ActivityItem",
  props: {
    activity: {
      required: true
    }
  },
  computed: {
    senderName() {
      let senderName = "";
      if (this.activity.senderEmail) {
        senderName = this.activity.senderEmail.split("@")[0];
      }
      return senderName;
    },
    senderFullEmail() {
      let senderFullEmail = "";
      if (this.activity.senderEmail) {
        senderFullEmail = this.activity.senderEmail;
      }
      return senderFullEmail;
    },
    receiver() {
      let recipientEmails = "";
      if (this.activity.recipientEmails.length) {
        recipientEmails = this.activity.recipientEmails[0].split("@")[0];
      }
      return recipientEmails;
    },
    receiverFullEmail() {
      let recipientFullEmail = "";
      if (this.activity.recipientEmails.length) {
        recipientFullEmail = this.activity.recipientEmails[0];
      }
      return recipientFullEmail;
    },
    otherReceivers() {
      let otherReceivers = "";
      if (
        this.activity.numberOfRecipients > 1 &&
        (this.activity.activityType.includes("OUTGOING_NEW") ||
          this.activity.activityType.includes("OUTGOING_DELETED_BY_SENDER"))
      ) {
        let recipientEmails = [...this.activity.recipientEmails];
        const count = recipientEmails.length - 1;
        const fullEmails = recipientEmails;
        fullEmails.shift();
        otherReceivers = this.$t("activity-other-receivers", {
          count,
          fullEmails
        });
      }

      return otherReceivers;
    }
  }
};
</script>
